module.exports = __webpack_public_path__ + "static/media/peda_page03.f861cb6b.png";